const normalizeDonationMinimum = donationMinimum =>
  Number(donationMinimum) || 0;

const isActivationFulfilled = (team = {}, donationMinimum = 0) => {
  const minimum = normalizeDonationMinimum(donationMinimum);
  if (minimum <= 0) {
    return true;
  }

  return Boolean(team.scholarship) || Number(team.totalRaised) >= minimum;
};

export { normalizeDonationMinimum, isActivationFulfilled };
